<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="disclaimer"><a id="page_5"></a>disclaimer</h2>
<p class="indent">At the time this book was written all information in this book was believed by the author to be correct and accurate. Information on gut health changes frequently as more research is being completed. Always keep yourself up-to-date by reading reputable, peer-reviewed, current publications and speaking with your healthcare provider. The author shall have no liability of any kind for damages of any nature, however caused. The author will not accept any responsibility for any omissions, misinterpretations, or misstatements that may exist within this book. The author does not endorse any product or company listed in this book. Always consult with your healthcare provider for medical advice as well as recommendations on any type of drug, supplement, or herbal supplement you plan on taking. The author is not engaged in rendering medical services, and this book should not be construed as medical advice; nor should it take the place of being properly diagnosed and monitored by your regular healthcare provider.<a id="page_6"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// disclaimer.vue?3c96261e